import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { GiftCardBooking } from 'app/typings/core/admin/giftcards/giftcardBookings';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useGiftCardBookings(giftCardCode: string) {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.giftcard, { code: giftCardCode }],
    queryFn: giftCardCode
      ? () =>
          apiRequest({
            path: ENDPOINTS.getGiftCardBookings,
            params: { code: giftCardCode },
          }) as Promise<GiftCardBooking[]>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!giftCardCode,
  });
}
